import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface SpinnerOverlayProps {
  show: boolean;
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: 'white' | 'black' | 'gray';
  backdropOpacity?: number; // 0 to 1
  className?: string;
  blockInteraction?: boolean; // when true, overlay captures pointer events
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({
  show,
  message,
  size = 'md',
  color = 'white',
  backdropOpacity = 0.3,
  className = '',
  blockInteraction = true,
}) => {
  if (!show) return null;
  const opacity = Math.max(0, Math.min(1, backdropOpacity));
  const backdropStyle = { backgroundColor: `rgba(0,0,0,${opacity})` } as React.CSSProperties;
  const pointerClass = blockInteraction ? '' : 'pointer-events-none';

  return (
    <div className={`fixed inset-0 z-[1000] ${pointerClass} ${className}`} aria-busy="true" role="alert" aria-live="polite">
      <div className="absolute inset-0" style={backdropStyle} />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex items-center gap-3 bg-black/60 text-white px-4 py-2 rounded-full shadow-lg">
          <LoadingSpinner size={size} color={color} />
          {message && <span className="text-sm">{message}</span>}
        </div>
      </div>
    </div>
  );
};

export default SpinnerOverlay;
